import React from "react";
import { Image, Label, Panel } from "lib/components";

export function Tool({ caption, selected, setSelected, onUse, type, imageProps={} }) {
  let selProps;
  if (selected) {
    selProps = { backgroundColor: "#3399FF", color: "#EEEEEE" };
    imageProps = {fill:"#FFF"}
  }
  else
    imageProps = {fill: "#979797"};
  let imageName = "designer/" + type.charAt(0).toUpperCase() + type.slice(1);
  return (
    <Panel fillRow {...selProps} cursor="pointer" onClick={() => setSelected(type)} onDoubleClick={() => {if (type !== "pointer") onUse(type)}} >
      <Image image={imageName} {...imageProps} width={32} height={28} noRowBreak />
      <Label caption={caption} fontSize="small" allowSelection={false} paddingLeft={8} paddingTop={8} fillRow />
    </Panel>
  );
}
